export default __webpack_public_path__ + "static/media/img_papaground03.ecac25aa.jpg";